import { SeoBlock } from 'models/SeoBlock';
import Markdown from 'components/Shared/Markdown';
import styles from './seo.scss';
import { Section } from 'components/Section';
import { useState } from 'react';
import { Button } from 'components/Button';
import { NO_ELEMENT, rm } from 'utils';
import cn from 'classnames';

interface ExtendendDescriptionProps {
  content: string | undefined;
}

interface SeoProps extends SeoBlock {
  usePadding: boolean | undefined;
}

export const SeoSection = ({
  header,
  description,
  extendedDescription,
  usePadding = true
}: SeoProps) => (
  <Section contentClassName={cn(styles.infoBlock, { [styles.infoPadding]: usePadding })}>
    <h1 className={styles.header}>{header}</h1>
    {description && <p className={styles.description}>{description}</p>}
    <ExtendendDescription content={extendedDescription} />
  </Section>
);

export const ExtendendDescription = ({ content }: ExtendendDescriptionProps) => {
  const [contentVisible, setContentVisible] = useState(false);
  const showSeoBlock = () => setContentVisible(true);

  if (content === undefined || content === '') {
    return NO_ELEMENT;
  }

  return (
    <div>
      {!contentVisible ? (
        <Button appearance="tertiary" border="thin" invert size="medium" onClick={showSeoBlock}>
          {rm('read_more')}
        </Button>
      ) : (
        NO_ELEMENT
      )}
      <Markdown
        className={contentVisible ? styles.description : styles.hidden}
        content={content}
        tag="div"
      />
    </div>
  );
};
